import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionComponent from '../../../../components/utils/SectionComponent'
import "./financialsOperationalList.scss"

function FinancialsOperationalList() {
  const {t} = useTranslation()

  return (
    <div className='container-product-performance-list'>
      <div className="texts-product-performance-list-financial">
        
        <SectionComponent title={t("corp_chain.fin_chain.title")} text={t("corp_chain.fin_chain.section_text_1")}>
          <p>{t("corp_chain.fin_chain.section_text_2")}</p>
          <p>{t("corp_chain.fin_chain.section_text_3")}</p>
        </SectionComponent>

        <SectionComponent title={t("corp_chain.op_chain.title")} text={t("corp_chain.op_chain.section_text_1")}>
          <p>{t("corp_chain.op_chain.section_text_2")}</p>
        </SectionComponent>

        <SectionComponent title={t("corp_chain.corp_policies.title")} text={t("corp_chain.corp_policies.section_text_1")}>
          <p>{t("corp_chain.corp_policies.section_text_2")}</p>
        </SectionComponent>

      </div>
    </div>
  )
}

export default FinancialsOperationalList